<template>
  <div class="row">
    <p class="title-get-admin tltle-get-padding col-12">Metadata</p>
    <volcan-input-text
      :disabled="seo.pageTitleSync"
      v-model="seo.pageTitle"
      text="Balise de titre"
      class="col-12"
    />
    <volcan-input-text
      :disabled="seo.friendlyUrlSync"
      v-model="seo.friendlyUrl"
      text="Nom unique pour Url"
      class="col-12"
    />
    <volcan-input-textarea
      v-model="seo.metaDescription"
      text="Balise de description"
      class="col-12"
    />
    <volcan-input-textarea
      v-model="seo.metaKeyword"
      text="Balise de mots-clés"
      class="col-12"
    />

    <p class="title-get-admin tltle-get-padding col-12">Balise OG</p>
    <!-- <volcan-input-text v-model="seo.ogUrl" text="Url de partage" /> -->
    <volcan-input-text
      :disabled="seo.pageTitleSync"
      v-model="seo.ogTitle"
      text="Og:Title"
      class="col-12"
    />
    <volcan-input-text v-model="seo.ogType" text="Og:Type" class="col-12" />

    <volcan-input-text
      v-model="seo.ogDescription"
      text="Og:Description"
      class="col-12"
    />

    <volcan-dropzone
      v-if="!imageSync"
      :isResource="true"
      :isSeo="true"
      v-model="doc"
      :options="{ maxFiles: 1 }"
      text="Og:Image"
      class="col-12"
    />

    <p class="title-get-admin tltle-get-padding col-12">Paramètres</p>
    <volcan-input-checkbox
      v-model="seo.noIndex"
      text="Empêcher l’indexation de cette page par les moteurs de recherche"
      class="col-12"
    />
    <volcan-input-checkbox
      v-model="seo.noFollow"
      text="Empêcher le suivi des liens de cette page par les moteurs de recherche"
      class="col-12"
    />
    <!-- <volcan-input-checkbox v-model="seo.excludeInSiteMap" text="Exclure cette page du plan du site" /> -->
    <volcan-input-checkbox
      v-model="seo.pageTitleSync"
      text="Synchroniser la balise de titre"
      class="col-12"
    />
    <volcan-input-checkbox
      v-model="seo.friendlyUrlSync"
      text="Synchroniser le permalien"
      class="col-12"
    />
  </div>
</template>
<script>
export default {
  name: "volcan-seo",
  props: ["seo", "imageSync"],
  data: function() {
    return {
      doc: null
    };
  },
  beforeMount() {
    if (!this.imageSync && this.seo.ogImage) {
      this.doc = { path: this.seo.ogImage, name: "" };
    }
  },
  mounted: function() {},
  watch: {
    doc() {
      if (this.doc) {
        this.seo.ogImage = this.doc.path;
      } else {
        this.seo.ogImage = "";
      }
    }
  },
  methods: {},
  computed: {}
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// components/Seo/index.vue